import IrrWidget from './IrrWidget'

export default IrrWidget
